




























import getCraftPages from '~/queries/craft-pages.gql'
import pageMixin from '@bkwld/cloak/mixins/page'
import { makeJsonLdArticleTag } from 'library/services/json-ld'

export default

	mixins: [ pageMixin ]

	# Structured meta
	head: -> {
		...@buildHead
			title: @page.title
		script: [ makeJsonLdArticleTag
			title: @page.title
			image: @metaImage
			publishedAt: new Date @page.dateCreated
			updatedAt: new Date @page.dateUpdated
			author: "Papa & Barkley"
		]
	}

	# Get Tower data
	asyncData: ({ app, store, route }) ->
		# Get data
		[ page ] = await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'articles'
				type: 'template'
				uri: route.path.substr(1)
		return app.$notFound() unless page

		# Set data
		return { page }

	computed:

		categoryTitle: -> @page.articleCategory?[0]?.title || null
		catgegoryLink: -> "/learn/category/#{@page.articleCategory?[0]?.slug}"

		# determine the meta image for structured data
		# check for SEO image first. If not, then fallback
		# to the listing image.
		metaImage: ->
			if @page.seo[0]?.metaImage[0]?.url
				return @page.seo[0]?.metaImage[0]?.url
			else
				return @$makeImgixUrl @page.listingImage?[0]?.path


		# simulate the data for the
		# standard marquee block
		standardMarqueeBlock: ->
			body: [
				"<span class='eyebrow'>#{@categoryTitle}</span>" if @categoryTitle
				"<h1 class='style-h2'>#{@page.title}</h1>"
				"<p>#{@page.summary}</p>" if @page.summary
			].join ' '
			buttons: []
			height: 'tall'
			imageFull: @page.imageFull
			imageLeft: @page.imageLeft
			imageRight: @page.imageRight
			height: @page.marqueeHeight
			layout: @page.marqueeLayout
			videoBkgd: ''
			videoPosition: 'full'
			backgroundColor: '#5b7e96'

